import { useRef } from 'react';
import { useAppDispatch, useAppSelector } from '../../hooks/redux';
import { FlyoutTemplate } from '../../models/flyout.model';
import { selectFlyoutTemplate, toggleFlyout } from '../../store/slices/flyout.slice';
import { ProfileQuickView } from './ProfileQuickView';
import useOutsideClick from 'common/hooks/useOutsideClick';
import { FlyoutBase } from './Flyout';
import FilterViewFlyout from '../layouts/filters/FilterViewFlyout';

export function FlyoutLayout() {
  const dispatch = useAppDispatch();
  const flyoutTemplate = useAppSelector(selectFlyoutTemplate);
  const onClose = () => dispatch(toggleFlyout(false));
  const containerRef = useRef<HTMLDivElement>(null);

  useOutsideClick(containerRef, () => {
    onClose();
  });

  const renderFlyoutContent = () => {
    switch (flyoutTemplate) {
      case FlyoutTemplate.PROFILE_VIEW:
        return <ProfileQuickView />;
      case FlyoutTemplate.FILTER_VIEW:
        return <FilterViewFlyout />;
      default:
        return <div>No Flyout Template Provided</div>;
    }
  };

  return (
    <FlyoutBase rootClassName="profileQuickView" onOverlayClick={onClose}>
      {renderFlyoutContent()}
    </FlyoutBase>
  );
}
